import { render, staticRenderFns } from "./CardArea.vue?vue&type=template&id=246e0638&scoped=true&"
import script from "./CardArea.vue?vue&type=script&lang=js&"
export * from "./CardArea.vue?vue&type=script&lang=js&"
import style0 from "./CardArea.vue?vue&type=style&index=0&id=246e0638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246e0638",
  null
  
)

export default component.exports